export const ENUM_REQUEST_BEGIN = 'ENUM_REQUEST_BEGIN';
export const ENUM_REQUEST_SUCCESS = 'ENUM_REQUEST_SUCCESS';
export const ENUM_REQUEST_ERROR = 'ENUM_REQUEST_ERROR';

export const SEARCH_BEGIN = 'SEARCH_BEGIN';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_ERROR = 'SEARCH_ERROR';

export const CHANGE_HOTEL_SELECTION = 'CHANGE_HOTEL_SELECTION';

// Test
export const CHANGE_PRICING_SELECTION = 'CHANGE_PRICING_SELECTION';

export const SELECT_ALL_HOTELS = 'SELECT_ALL_HOTELS';

// Test
export const SELECT_ALL_PRICES = 'SELECT_ALL_PRICES';

export const GET_PRICING_LIST_FOR_SELECTED_HOTELS_BEGIN = 'GET_PRICING_LIST_FOR_SELECTED_HOTELS_BEGIN';
export const GET_PRICING_LIST_FOR_SELECTED_HOTELS_SUCCESS = 'GET_PRICING_LIST_FOR_SELECTED_HOTELS_SUCCESS';
export const GET_PRICING_LIST_FOR_SELECTED_HOTELS_ERROR = 'GET_PRICING_LIST_FOR_SELECTED_HOTELS_ERROR';

export const OVERRIDE_PRICING_BEGIN = 'OVERRIDE_PRICING_BEGIN';
export const OVERRIDE_PRICING_SUCCESS = 'OVERRIDE_PRICING_SUCCESS';
export const OVERRIDE_PRICING_ERROR = 'OVERRIDE_PRICING_ERROR';

export const SET_POLICY = 'SET_POLICY';

export const POLICY_GET_BEGIN = 'POLICY_GET_BEGIN';
export const POLICY_GET_SUCCESS = 'POLICY_GET_SUCCESS';
export const POLICY_GET_ERROR = 'POLICY_GET_ERROR';

export const POLICY_SEARCH_BEGIN = 'POLICY_SEARCH_BEGIN';
export const POLICY_SEARCH_SUCCESS = 'POLICY_SEARCH_SUCCESS';
export const POLICY_SEARCH_ERROR = 'POLICY_SEARCH_ERROR';

export const POLICY_SAVE_BEGIN = 'POLICY_SAVE_BEGIN';
export const POLICY_SAVE_SUCCESS = 'POLICY_SAVE_SUCCESS';
export const POLICY_SAVE_ERROR = 'POLICY_SAVE_ERROR';

export const PRICE_GET_BEGIN = 'PRICE_GET_BEGIN';
export const PRICE_GET_SUCCESS = 'PRICE_GET_SUCCESS';
export const PRICE_GET_ERROR = 'PRICE_GET_ERROR';

export const PRICE_GET_RANGE_BEGIN = 'PRICE_GET_RANGE_BEGIN';
export const PRICE_GET_RANGE_SUCCESS = 'PRICE_GET_RANGE_SUCCESS';
export const PRICE_GET_RANGE_ERROR = 'PRICE_GET_RANGE_ERROR';

export const GET_POLICIES_BEGIN = 'GET_POLICIES_BEGIN';
export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS';
export const GET_POLICIES_ERROR = 'GET_POLICIES_ERROR';

export const UPDATE_PRICE = 'UPDATE_PRICE';

export const BULK_UPDATE_PRICES = 'BULK_UPDATE_PRICES';

export const FILTER_PRICING = 'FILTER_PRICING';

// Inventory
export const SET_INVENTORY = 'SET_INVENTORY';
export const SET_MODEL_OBJECT = 'SET_MODEL_OBJECT';
export const SET_INVENTORYDATA = 'SET_INVENTORYDATA';

export const INVENTORY_GET_BEGIN = 'INVENTORY_GET_BEGIN';
export const INVENTORY_GET_SUCCESS = 'INVENTORY_GET_SUCCESS';
export const INVENTORY_GET_ERROR = 'INVENTORY_GET_ERROR';

export const INVENTORY_CHECK_BEGIN = 'INVENTORY_CHECK_BEGIN';
export const INVENTORY_CHECK_SUCCESS = 'INVENTORY_CHECK_SUCCESS';
export const INVENTORY_CHECK_ERROR = 'INVENTORY_CHECK_ERROR';

export const INVENTORY_SAVE_BEGIN = 'INVENTORY_SAVE_BEGIN';
export const INVENTORY_SAVE_SUCCESS = 'INVENTORY_SAVE_SUCCESS';
export const INVENTORY_SAVE_ERROR = 'INVENTORY_SAVE_ERROR';

export const INVENTORY_SEARCH_BEGIN = 'INVENTORY_SEARCH_BEGIN';
export const INVENTORY_SEARCH_SUCCESS = 'INVENTORY_SEARCH_SUCCESS';
export const INVENTORY_SEARCH_ERROR = 'INVENTORY_SEARCH_ERROR';

export const INVENTORY_RESET_PAGE_ON_ADD = 'INVENTORY_RESET_PAGE_ON_ADD';

export const LOAD_REQUEST_BEGIN = 'LOAD_REQUEST_BEGIN';
export const LOAD_REQUEST_SUCCESS = 'LOAD_REQUEST_SUCCESS';
export const LOAD_REQUEST_ERROR = 'LOAD_REQUEST_ERROR';

export const SET_GLOBAL_HOTEL = 'SET_GLOBAL_HOTEL';
export const SET_GLOBAL_ROOM_CATEGORY = 'SET_GLOBAL_ROOM_CATEGORY';
export const SET_HEADER_INFO = 'SET_HEADER_INFO';
